

export function renderKokonaisKuntoarvio(data, content) {
  const tekst = data?.teksti || "";
  const luokka = data?.luokka || "-";

  // If not selected → nothing printed
  if (!tekst.trim() || luokka === "-") return;

  const colorMap = {
    KL1: "#dc3545",
    KL2: "#dc3545",
    KL3: "#d0c407",
    KL4: "#04aa00",
    KL5: "#04aa00",
  };

  const color = colorMap[luokka] || "#6c757d";

  content.push({
    text: [
      { text: tekst.trim() },
      { text: " " }, // space before KL
      { text: luokka, fontSize: 14, bold: true, color },
    ],
    style: "paragraph",
    unbreakable: true,
  });
}
